import { AccountPresetIcon } from "./AccountPresetIcon";
import { ACCOUNT_ICON_OPTIONS, type AccountIconKey } from "./accountIconOptions";
import { cn } from "@/lib/cn";

type Props = {
  providerId: string;
  value: AccountIconKey;
  onChange: (iconKey: AccountIconKey) => void;
  disabled?: boolean;
};

export function AccountIconPicker({ providerId, value, onChange, disabled }: Props) {
  return (
    <div className="space-y-2">
      <p className="text-xs text-[var(--mail-muted)]">
        Gmail et Microsoft reprennent leur logo automatiquement. Choisissez une autre icône si vous
        le souhaitez.
      </p>
      <div
        className="grid grid-cols-3 gap-2 sm:grid-cols-7"
        role="radiogroup"
        aria-label="Icône du compte"
      >
        {ACCOUNT_ICON_OPTIONS.map((option) => {
          const selected = value === option.id;
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(option.id)}
              className={cn(
                "flex flex-col items-center gap-1.5 rounded-xl border px-2 py-2.5 transition",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--mail-accent)]",
                selected
                  ? "border-[var(--mail-accent)] bg-[var(--mail-accent-soft)] ring-1 ring-[var(--mail-accent)]/25"
                  : "border-[var(--mail-border-soft)] bg-[var(--mail-surface)] hover:border-[var(--mail-accent)]/30 hover:bg-[var(--mail-surface-hover)]",
                disabled && "pointer-events-none opacity-50"
              )}
            >
              <span className="flex h-9 w-9 items-center justify-center">
                <AccountPresetIcon
                  iconKey={option.id}
                  providerId={providerId}
                  className="h-7 w-7"
                />
              </span>
              <span className="w-full truncate text-center text-[10px] font-medium text-[var(--mail-text)]">
                {option.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
